<!-- login แล้วจะมาโผล่หน้านี้ (admin) -->
<template>
  <div>
    <!-- Navbar ของ Staff -->
    <StaffNavbar />
    <AlertBox ref="alertBox" />
    <StaffPageExcel ref="loanModal" />
    <div>
      <!-- Header ส่วนบนของหน้าจอ -->
      <header class="header">
        <h1>ตรวจสอบแบบคำขอกู้ยืมเงิน</h1>
      </header>
      <div>
        <!-- ส่วนของฟอร์มค้นหาคำขอกู้ยืม -->
        <div class="container-fluid">
          <div class="py-1 px-2">
            <div class="bg-secondary-light mb-3 shadow" id="search_form">
              <div style="background-color: #964040" class="p-3">
                <span>
                  <h4 class="text-white my-0">ตัวช่วยการค้นหา</h4>
                </span>
              </div>
              <div class="m-2">
                <div class="mb-5">
                  <div class="px-3">
                    <div class="search-fields">
                      <!-- ฟิลด์ รหัสนักศึกษา, ชื่อ, นามสกุล -->
                      <div class="row g-3 mb-3">
                        <div class="col-12 col-md-4">
                          <label for="student_id">รหัสนักศึกษา</label>
                          <input
                            type="number"
                            id="student_id"
                            class="form-control no-arrows"
                            placeholder="กรอกเลขรหัสนักศึกษา"
                            @wheel.prevent
                            v-model="studentId"
                            @input="filterNumber"
                            @keydown="blockInvalidKeys"
                            maxlength="13"
                          />
                        </div>
                        <div class="col-12 col-md-4">
                          <label for="first_name">ชื่อ</label>
                          <input
                            type="text"
                            id="first_name"
                            class="form-control"
                            placeholder="กรอกชื่อ"
                          />
                        </div>
                        <div class="col-12 col-md-4">
                          <label for="last_name">นามสกุล</label>
                          <input
                            type="text"
                            id="last_name"
                            class="form-control"
                            placeholder="กรอกนามสกุล"
                          />
                        </div>
                      </div>

                      <!-- ส่วนเลือกระดับการศึกษา, ปีการศึกษา, ภาคเรียน-->
                      <div class="row g-3 mb-2">
                        <div class="col-12 col-md-4">
                            <label>ระดับการศึกษา</label>
                            <select class="form-select" id="graduated_level">
                              <option selected disabled value="">
                                กรุณาเลือก
                              </option>
                              <option value="ปริญญาตรี">ปริญญาตรี</option>
                              <option value="ปริญญาโท">ปริญญาโท</option>
                              <option value="ประกาศนียบัตร">
                                ประกาศนียบัตร
                              </option>
                            </select>
                        </div>
                        <div class="col-12 col-md-4">
                            <label>ปีการศึกษา</label>
                            <select class="form-select" id="study_year">
                              <option selected disabled value="">
                                กรุณาเลือก
                              </option>
                              <option>2564</option>
                              <option>2565</option>
                              <option>2566</option>
                              <option>2567</option>
                              <option>2568</option>
                              <option>2569</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-4">
                            <label>ภาคเรียน</label>
                            <select class="form-select" id="study_semester">
                              <option selected disabled value="">
                                กรุณาเลือก
                              </option>
                              <option>1</option>
                              <option>2</option>
                              <option>3</option>
                            </select>
                        </div>
                      </div>

                      <!-- ส่วนเลือกวันที่ยื่นคำขอ -->
                      <div class="col-12 mt-3">
                        <label for="user_startSemesterStudy"
                          >วันที่ยื่นคำขอ</label
                        >
                        <div class="date-range-wrap">
                          <input
                            type="date"
                            class="form-control"
                            id="submission_date"
                          />
                          <span class="date-separator">ถึง</span>
                          <input
                            type="date"
                            class="form-control"
                            id="submission_date_end"
                          />
                        </div>
                      </div>

                      <div class="row g-3 mt-1">
                        <div class="col-12 col-lg-6">
                          <label for="loan_status_filter">สถานะคำขอ/สถานะสัญญา</label>
                          <button
                            type="button"
                            id="loan_status_filter"
                            class="form-control filter-select-button"
                            @click="openFilterPopup('loanStatus')"
                          >
                            <span>{{ filterButtonText("loanStatus") }}</span>
                            <i class="fa-solid fa-filter"></i>
                          </button>
                        </div>

                        <div class="col-12 col-lg-6">
                          <label for="student_type_filter">ประเภทผู้กู้ยืม</label>
                          <button
                            type="button"
                            id="student_type_filter"
                            class="form-control filter-select-button"
                            @click="openFilterPopup('studentType')"
                          >
                            <span>{{ filterButtonText("studentType") }}</span>
                            <i class="fa-solid fa-filter"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- ปุ่มล้างค่า และค้นหา -->
              <div class="px-3 pb-3">
                <button
                  class="btn btn-secondary"
                  name="clearValues"
                  @click="clearInput"
                >
                  ล้างค่า
                </button>
                <button
                  style="background-color: #964040"
                  class="btn text-white float-end"
                  name="search"
                  @click="getStudentLoanSearch"
                >
                  ค้นหา
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ส่วนแสดงรายละเอียดคำขอกู้ยืม -->
      <div class="container-fluid screen-control">
        <div class="py-1 px-2">
          <div class="bg-secondary-light shadow">
            <div style="background-color: #964040" class="text-white p-3">
              <div class="row">
                <div class="col">
                  <div class="row">
                    <div class="col"><h4>รายละเอียดคำขอกู้ยืมเงิน</h4></div>
                  </div>

                  <div
                    class="d-flex justify-content-start align-items-center my-2"
                  >
                    <p class="m-0">ทั้งหมด</p>
                    <select
                      name="total_loan_number"
                      id="total_loan_number"
                      class="form-select"
                      style="max-width: 100px"
                      v-model="itemsPerPage"
                      @change="handleItemsPerPageChange"
                    >
                      <option value="50" selected>50</option>
                      <option value="100">100</option>
                    </select>
                    <p class="m-0">รายการ</p>
                  </div>
                </div>

                <!-- checkbox controller -->
                <div
                  class="col text-end align-self-center"
                  v-show="checkedLoans.length > 0"
                >
                  <div>
                    <div
                      class="d-flex justify-content-end align-items-center mb-4"
                    >
                      <p class="my-auto">
                        <b>เลือกแล้ว {{ checkedLoans.length }} รายการ</b>
                      </p>
                      <div>
                        <input
                          type="checkbox"
                          id="checkbox_loan_all"
                          class="form-check-input me-1"
                        />
                        <label for="checkbox_loan_all"
                          ><b>เลือกทั้งหมด</b></label
                        >
                      </div>
                    </div>
                    <div class="d-flex gap-2 justify-content-end">
                      <button class="btn btn-light" @click="openLoanModal">
                        ดาวน์โหลดคำขอกู้
                      </button>
                      <button
                        class="btn btn-light"
                        @click="confirmBoxWithValue"
                      >
                        เปลี่ยนสถานะคำข้อกู้
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="row">
                  <div class="col">
                    <div
                      class="pagination-container"
                      v-if="totalLoan > itemsPerPage"
                    >
                      <!-- Previous Button -->
                      <button
                        class="btn btn-secondary"
                        @click="prevPage"
                        :disabled="currentPage === 1"
                      >
                        ก่อนหน้า
                      </button>

                      <!-- First Page -->
                      <button
                        class="btn m-1"
                        :class="{
                          'btn-info': currentPage === 1,
                          'btn-secondary': currentPage !== 1,
                        }"
                        @click="changePage(1)"
                      >
                        1
                      </button>

                      <!-- Dots Before Middle Pages -->
                      <span v-if="currentPage > 4">...</span>

                      <!-- Middle Pages (Dynamic Range) -->
                      <button
                        v-for="page in dynamicPageRange()"
                        :key="page"
                        class="btn m-1"
                        :class="{
                          'btn-info': currentPage === page,
                          'btn-secondary': currentPage !== page,
                        }"
                        @click="changePage(page)"
                      >
                        {{ page }}
                      </button>

                      <!-- Dots After Middle Pages -->
                      <span v-if="currentPage < totalPages() - 3">...</span>

                      <!-- Last Page -->
                      <button
                        class="btn m-1"
                        :class="{
                          'btn-info': currentPage === totalPages(),
                          'btn-secondary': currentPage !== totalPages(),
                        }"
                        @click="changePage(totalPages())"
                      >
                        {{ totalPages() }}
                      </button>

                      <!-- Next Button -->
                      <button
                        class="btn btn-secondary"
                        @click="nextPage"
                        :disabled="currentPage === totalPages()"
                      >
                        ถัดไป
                      </button>

                      <select
                        v-model="currentPage"
                        class="mx-2 px-3 py-2 rounded rounded-3"
                        @change="changePage(currentPage)"
                      >
                        <option
                          v-for="page in totalPages()"
                          :key="page"
                          :value="page"
                        >
                          {{ page }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col">
                    <button
                      @click="getStudentLoanSearch"
                      class="float-end btn border-0"
                      :disabled="isLoading"
                    >
                      <i
                        class="fa-solid fa-rotate-right text-white"
                        :class="{ spin: isLoading }"
                      ></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="px-0">
              <div class="table-responsive">
                <table class="table table-secondary" style="width: 100%; table-layout: fixed;">
                  <thead>
                    <tr class="text-start align-top">
                      <th scope="col" class="text-center" style="width:3%;">
                        <div>
                          <div><label for="select-all-checkbox">เลือก</label></div>
                          <div class="d-flex justify-content-center">
                            <input
                              type="checkbox"
                              id="select-all-checkbox"
                              class="form-check-input p-0"
                            />
                          </div>
                        </div>
                      </th>
                      <th scope="col" style="width:7%;">
                        วันที่ยื่นคำขอ
                        <button
                          @click="toggleSort('created_at')"
                          class="p-0 border rounded bg-transparent"
                        >
                          <i :class="getSortIcon('created_at')"></i>
                        </button>
                      </th>
                      <th scope="col" style="width:7%;">
                        รหัสนักศึกษา
                        <button
                          @click="toggleSort('user_studentID')"
                          class="p-0 border rounded bg-transparent"
                        >
                          <i :class="getSortIcon('user_studentID')"></i>
                        </button>
                      </th>
                      <th scope="col" style="width:7%;">ชื่อ-นามสกุล</th>
                      <th scope="col" style="width:6%;">ระดับการศึกษา</th>
                      <th scope="col" style="width:6%;">ปีการศึกษา/ภาคเรียน</th>
                      <th scope="col" style="width:13%;">
                        สำนักวิชา
                        <button
                          @click="toggleSort('user_faculty')"
                          class="p-0 border rounded bg-transparent"
                        >
                          <i :class="getSortIcon('user_faculty')"></i>
                        </button>
                      </th>
                      <th scope="col" style="width:12%;">
                        สาขา
                        <button
                          @click="toggleSort('user_fieldStudy')"
                          class="p-0 border rounded bg-transparent"
                        >
                          <i :class="getSortIcon('user_fieldStudy')"></i>
                        </button>
                      </th>
                      <th scope="col" style="width:7%;">
                        ประเภท
                        <button
                          type="button"
                          class="p-0 border rounded bg-transparent"
                          :class="{ 'active-filter': selectedStudentTypes.length > 0 }"
                          title="กรองประเภทผู้กู้ยืม"
                          @click="openFilterPopup('studentType')"
                        >
                          <i class="fa-solid fa-filter"></i>
                        </button>
                        <button
                          @click="toggleSort('user_studentType')"
                          class="p-0 border rounded bg-transparent"
                          title="เรียงตามประเภทผู้กู้ยืม"
                        >
                          <i :class="getSortIcon('user_studentType')"></i>
                        </button>
                      </th>
                      <th scope="col" style="width:8%;">
                        สถานะ
                        <button
                          type="button"
                          class="p-0 border rounded bg-transparent"
                          :class="{ 'active-filter': selectedLoanStatuses.length > 0 }"
                          title="กรองสถานะคำขอ"
                          @click="openFilterPopup('loanStatus')"
                        >
                          <i class="fa-solid fa-filter"></i>
                        </button>
                        <button
                          @click="toggleSort('loan_status')"
                          class="p-0 border rounded bg-transparent"
                          title="เรียงตามสถานะคำขอ"
                        >
                          <i :class="getSortIcon('loan_status')"></i>
                        </button>
                      </th>
                      <th scope="col" style="width:8%;">รายละเอียด</th>
                      <th scope="col" style="width:7%;">โดย</th>
                      <th scope="col" style="width:3%;"></th>
                      <th scope="col" style="width:3%;"></th>
                      <th scope="col" style="width:3%;"></th>
                    </tr>
                  </thead>
                  <tbody v-if="isLoading">
                    <tr>
                      <td colspan="14" class="text-center py-4">
                        <div
                          class="spinner-border text-danger"
                          role="status"
                          style="width: 3rem; height: 3rem"
                        >
                          <span class="visually-hidden">Loading...</span>
                        </div>
                        <p class="mt-2">กำลังโหลดข้อมูล...</p>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else id="result_table" v-html="result_print"></tbody>
                </table>
              </div>
            </div>

            <div style="background-color: #964040" class="text-white p-3">
              <div class="pagination-container" v-if="totalLoan > itemsPerPage">
                <!-- Previous Button -->
                <button
                  class="btn btn-secondary"
                  @click="prevPage"
                  :disabled="currentPage === 1"
                >
                  ก่อนหน้า
                </button>

                <!-- First Page -->
                <button
                  class="btn m-1"
                  :class="{
                    'btn-info': currentPage === 1,
                    'btn-secondary': currentPage !== 1,
                  }"
                  @click="changePage(1)"
                >
                  1
                </button>

                <!-- Dots Before Middle Pages -->
                <span v-if="currentPage > 4">...</span>

                <!-- Middle Pages (Dynamic Range) -->
                <button
                  v-for="page in dynamicPageRange()"
                  :key="page"
                  class="btn m-1"
                  :class="{
                    'btn-info': currentPage === page,
                    'btn-secondary': currentPage !== page,
                  }"
                  @click="changePage(page)"
                >
                  {{ page }}
                </button>

                <!-- Dots After Middle Pages -->
                <span v-if="currentPage < totalPages() - 3">...</span>

                <!-- Last Page -->
                <button
                  class="btn m-1"
                  :class="{
                    'btn-info': currentPage === totalPages(),
                    'btn-secondary': currentPage !== totalPages(),
                  }"
                  @click="changePage(totalPages())"
                >
                  {{ totalPages() }}
                </button>

                <!-- Next Button -->
                <button
                  class="btn btn-secondary"
                  @click="nextPage"
                  :disabled="currentPage === totalPages()"
                >
                  ถัดไป
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StaffNavbar from "./NavBar_staff.vue";
import Swal from "sweetalert2";
import AlertBox from "../AlertBox.vue";
import StaffPageExcel from "./StaffPage_Excel.vue";
import { formatEmailFirstName } from "@/mixins/displayName";
import { getVerifiedZipBlob } from "@/utils/zipDownload";

export default {
  name: "StaffPage_home",
  components: {
    // เอา หน้าอื่นมาใช้
    StaffNavbar,
    AlertBox,
    StaffPageExcel,
  },

  data() {
    return {
      // เก็บค่าที่ผู้ใช้ป้อน
      studentId: "",
      result_print: "",
      staffEmail: "",
      totalLoan: 0,
      allLoans: [], // เก็บข้อมูลทั้งหมด
      currentPage: 1, // หน้าปัจจุบัน
      itemsPerPage: 100, // จำนวนรายการต่อหน้า
      checkedLoans: [], // เก็บรายการที่ถูกเลือก
      isLoading: false,
      selectedLoanStatuses: [],
      selectedStudentTypes: [],
      loanStatusOptions: [
        "อนุมัติ",
        "ผ่านการตรวจสอบคุณสมบัติ",
        "อยู่ระหว่างดำเนินการ",
        "ตีกลับเพื่อแก้เอกสาร",
        "อยู่ระหว่างตรวจสอบคุณสมบัติผู้กู้ยืม",
        "รอผลการพิจารณาจากกองทุน กยศ.",
        "ไม่อนุมัติ",
      ],
      studentTypeOptions: [
        "รายใหม่",
        "รายเก่า",
        "ผู้ยืมเงินเกินกว่าจำนวนปีที่กำหนดไว้ในหลักสูตร",
      ],

      // sorting
      isUpDate: true,
      isUpStudentID: false,
      isUpFaculty: false,
      isUpFieldStudy: false,
      isUpStudentType: false,
      sortFields: [{ key: "created_at", order: "DESC" }],
    };
  },
  methods: {
    getFilterConfig(filterKey) {
      if (filterKey === "loanStatus") {
        return {
          title: "เลือกสถานะคำขอ/สถานะสัญญา",
          options: this.loanStatusOptions,
          selectedKey: "selectedLoanStatuses",
        };
      }

      return {
        title: "เลือกประเภทผู้กู้ยืม",
        options: this.studentTypeOptions,
        selectedKey: "selectedStudentTypes",
      };
    },

    filterButtonText(filterKey) {
      const { selectedKey } = this.getFilterConfig(filterKey);
      const count = this[selectedKey].length;
      return count === 0 ? "ทั้งหมด" : `เลือกแล้ว ${count} รายการ`;
    },

    openFilterPopup(filterKey) {
      const { title, options, selectedKey } = this.getFilterConfig(filterKey);
      const selectedValues = this[selectedKey];
      const isAllSelected = selectedValues.length === 0;
      const checkboxHtml = options
        .map(
          (option, index) => `
            <label class="loan-filter-option" for="loan-filter-${index}">
              <input
                id="loan-filter-${index}"
                class="form-check-input loan-filter-checkbox"
                type="checkbox"
                value="${option}"
                ${isAllSelected || selectedValues.includes(option) ? "checked" : ""}
              />
              <span>${option}</span>
            </label>`
        )
        .join("");

      Swal.fire({
        title,
        html: `
          <div class="loan-filter-popup">
            <label class="loan-filter-option loan-filter-all" for="loan-filter-all">
              <input id="loan-filter-all" class="form-check-input" type="checkbox" ${
                isAllSelected ? "checked" : ""
              } />
              <span>ทั้งหมด</span>
            </label>
            <hr />
            ${checkboxHtml}
          </div>`,
        showCancelButton: true,
        confirmButtonText: "ใช้ตัวกรอง",
        cancelButtonText: "ยกเลิก",
        confirmButtonColor: "#964040",
        focusConfirm: false,
        didOpen: () => {
          const allCheckbox = document.getElementById("loan-filter-all");
          const optionCheckboxes = Array.from(
            document.querySelectorAll(".loan-filter-checkbox")
          );

          allCheckbox.addEventListener("change", (event) => {
            optionCheckboxes.forEach((checkbox) => {
              checkbox.checked = event.target.checked;
            });
          });

          optionCheckboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", () => {
              allCheckbox.checked = optionCheckboxes.every(
                (item) => item.checked
              );
            });
          });
        },
        preConfirm: () => {
          const checkedValues = Array.from(
            document.querySelectorAll(".loan-filter-checkbox:checked")
          ).map((checkbox) => checkbox.value);

          if (checkedValues.length === 0) {
            Swal.showValidationMessage("กรุณาเลือกอย่างน้อย 1 รายการ");
            return false;
          }

          return checkedValues.length === options.length ? [] : checkedValues;
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this[selectedKey] = result.value;
          this.getStudentLoanSearch();
        }
      });
    },

    async getSession() {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/session/get/session`,
          {
            method: "GET",
            credentials: "include",
          }
        );
        if (response.ok) {
          const session = await response.json();
          return session;
        } else if (response.status === 401) {
          // No session found, redirect to login page
          this.$router.replace("/login");
          throw new Error("No session found. Redirecting to login.");
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        } else {
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        alert(error.message);
      }
    },

    filterNumber(event) {
      // ตรวจสอบและลบตัวอักษรที่ไม่ใช่ตัวเลข
      const value = event.target.value.replace(/[^0-9]/g, ""); // ลบสิ่งที่ไม่ใช่ตัวเลข
      this.studentId = value.slice(0, 10); // จำกัดความยาวไม่เกิน 13
    },

    blockInvalidKeys(event) {
      // ปิดการทำงานของ e, +, และ -
      if (["e", "E", "+", "-"].includes(event.key)) {
        event.preventDefault();
      }
    },

    toggleSort(key) {
      const index = this.sortFields.findIndex((f) => f.key === key);
      if (index !== -1) {
        // Toggle order for the existing key
        this.sortFields[index].order =
          this.sortFields[index].order === "ASC" ? "DESC" : "ASC";
        // Keep only this key
        this.sortFields = [this.sortFields[index]];
      } else {
        // Replace sortFields with new key ascending
        this.sortFields = [{ key, order: "ASC" }];
      }

      this.getStudentLoanSearch();
    },

    getSortIcon(key) {
      const field = this.sortFields.find((f) => f.key === key);
      if (!field) return "fas fa-sort";
      return field.order === "ASC"
        ? "fas fa-chevron-up"
        : "fas fa-chevron-down";
    },

    formatManagedByName(value) {
      return formatEmailFirstName(value);
    },

    result_show(value) {
      this.allLoans = value.data;
      this.totalLoan = value.total;
      this.currentPage = 1;
      this.updatePagination();
    },

    handleItemsPerPageChange() {
      this.currentPage = 1;
      this.updatePagination();
    },

    updatePagination() {
      // No slicing needed anymore since the backend sends paginated data
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      const paginatedData = this.allLoans.slice(startIndex, endIndex);
      const statusClassMap = {
        อยู่ระหว่างดำเนินการ: "style='color: orange;'",
        อนุมัติ: "style='color: #00cc44;''",
        ผ่านการตรวจสอบคุณสมบัติ: "class='text-success'",
        อยู่ระหว่างตรวจสอบคุณสมบัติผู้กู้ยืม: "class='text-secondary'",
        "รอผลการพิจารณาจากกองทุน กยศ.": "class='text-warning'",
        ตีกลับเพื่อแก้เอกสาร: "class='text-primary'",
        ไม่อนุมัติ: "class='text-danger'",
      };

      this.result_print = "";
      document.getElementById("select-all-checkbox").checked = false;

      this.visiblePages = this.calculateVisiblePages();

      paginatedData.forEach((uld) => {
        this.result_print += `<tr>`;
        this.result_print += `<td class="text-center"><input type="checkbox" class="form-check-input form-check-select" data-id="${
          uld.public_id
        }" ${this.checkedLoans.includes(uld.public_id) ? "checked" : ""}></td>`;
        this.result_print += `<td><p class="m-0">${uld.date}</p><p class="text-secondary">${uld.time}</p></td>`;
        this.result_print += `<td>${uld.user_studentID}</td>`;
        this.result_print += `<td>${uld.user_username} ${uld.user_surname}</td>`;
        this.result_print += `<td>${uld.user_lvlStudy}</td>`;
        this.result_print += `<td>ปีการศึกษา ${uld.user_yearStudy}<p class="text-secondary">ภาคเรียนที่ ${uld.user_semesterStudy}</p></td>`;
        this.result_print += `<td>${uld.user_faculty}</td>`;
        this.result_print += `<td>${uld.user_fieldStudy}</td>`;
        this.result_print += `<td>${uld.user_studentType}</td>`;

        const loanStatusAttr = statusClassMap[uld.loan_status] || "";
        this.result_print += `<td ${loanStatusAttr}>${uld.loan_status}</td>`;

        this.result_print += `<td style="max-width: 300px; word-wrap: break-word; white-space: normal;">${
          uld.loan_details ?? "-"
        }</td>`;
        this.result_print += `<td>${
          this.formatManagedByName(uld.managed_by)
        }</td>`;
        this.result_print += `<td><button type="button" class="btn border-0" id="btn-${
          uld.public_id
        }"><i class="fa-solid fa-eye" style="color: #964040;"></i></button></td>`;
        this.result_print += `<td><button class="btn border-0" id="btn-delete-${uld.public_id}"><i class="fa-solid fa-trash" style="color: #964040;"></i></button></td>`;
        this.result_print += `<td><button class="btn border-0" id="btn-pdf-${uld.public_id}" title="ดาวน์โหลด ZIP (PDF)"><i class="fa-solid fa-file-zipper" style="color: #964040;"></i></button></td>`;
        this.result_print += `</tr>`;
      });

        this.$nextTick(() => {
          paginatedData.forEach((uld) => {
          const buttonView = document.getElementById(`btn-${uld.public_id}`);
          if (buttonView) {
            buttonView.onclick = () => {
              window.open(`/staff/info?id=${uld.public_id}&ts=${Date.now()}`, "_blank");
            };
          }

          const buttonDelete = document.getElementById(
            `btn-delete-${uld.public_id}`
          );
          if (buttonDelete) {
            buttonDelete.addEventListener("click", () => {
              Swal.fire({
                title: "คุณแน่ใจหรือไม่?",
                html: `
                    <p>พิมพ์ <strong>'ฉันต้องการลบข้อมูล'</strong> เพื่อยืนยันการลบคำขอเงินกู้ยืม</p>
                    <input id="swal-input" class="swal2-input" placeholder="ฉันต้องการลบข้อมูล" />
                    <button id="fill-btn" class="swal2-confirm swal2-styled" style="background-color: #666; margin-top: 10px;">
                      กรอกข้อความอัตโนมัติ
                    </button>
                  `,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#964040",
                cancelButtonColor: "#d33",
                cancelButtonText: "ยกเลิก",
                confirmButtonText: "ใช่, ลบเลย!",
                focusConfirm: false,
                preConfirm: () => {
                  const input = document.getElementById("swal-input").value;
                  if (input !== "ฉันต้องการลบข้อมูล") {
                    Swal.showValidationMessage(
                      "คุณต้องพิมพ์ให้ตรง: ฉันต้องการลบข้อมูล"
                    );
                  }
                  return input;
                },
                didOpen: () => {
                  const fillBtn = document.getElementById("fill-btn");
                  fillBtn.addEventListener("click", () => {
                    document.getElementById("swal-input").value =
                      "ฉันต้องการลบข้อมูล";
                  });
                },
              }).then((result) => {
                if (
                  result.isConfirmed &&
                  result.value === "ฉันต้องการลบข้อมูล"
                ) {
                  this.deleteSystemStatus(uld.public_id);
                }
              });
            });
          }
          const button_pdf = document.getElementById(
            `btn-pdf-${uld.public_id}`
          );
          if (button_pdf) {
            button_pdf.addEventListener("click", () => {
              this.getPDFpersonalData(uld.public_id, uld.user_studentID);
              // alert(uld.public_id);
            });
          }
        });

        const checkboxes = document.querySelectorAll(".form-check-select");
        checkboxes.forEach((checkbox) => {
          const loanId = checkbox.getAttribute("data-id");

          checkbox.addEventListener("change", (e) => {
            if (e.target.checked) {
              if (!this.checkedLoans.includes(loanId)) {
                this.checkedLoans.push(loanId);
              }
            } else {
              this.checkedLoans = this.checkedLoans.filter(
                (id) => id !== loanId
              );
            }

            // 🔄 Update "Select All on This Page" checkbox
            const currentPageIds = Array.from(checkboxes).map((cb) =>
              cb.getAttribute("data-id")
            );
            const allPageChecked = currentPageIds.every((id) =>
              this.checkedLoans.includes(id)
            );
            const selectAllCheckbox = document.getElementById(
              "select-all-checkbox"
            );
            if (selectAllCheckbox) {
              selectAllCheckbox.checked = allPageChecked;
            }

            // 🔄 Update "Select All Across All Pages" checkbox
            const allIds = this.allLoans.map((loan) => loan.public_id);
            const allChecked = allIds.every((id) =>
              this.checkedLoans.includes(id)
            );
            const checkboxLoanAll =
              document.getElementById("checkbox_loan_all");
            if (checkboxLoanAll) {
              checkboxLoanAll.checked = allChecked;
            }
          });
        });

        // Select All Checkbox
        const selectAllCheckbox = document.getElementById(
          "select-all-checkbox"
        );
        if (selectAllCheckbox) {
          selectAllCheckbox.addEventListener("change", (e) => {
            const isChecked = e.target.checked;
            const checkboxes = document.querySelectorAll(".form-check-select");

            const currentPageIds = [];
            checkboxes.forEach((cb) => {
              const id = cb.getAttribute("data-id");
              currentPageIds.push(id);
            });

            if (isChecked) {
              // Add current page's checkboxes to the list
              currentPageIds.forEach((id) => {
                if (!this.checkedLoans.includes(id)) {
                  this.checkedLoans.push(id);
                }
              });
            } else {
              // Remove current page's checkboxes from the list
              this.checkedLoans = this.checkedLoans.filter(
                (id) => !currentPageIds.includes(id)
              );
            }

            checkboxes.forEach((cb) => {
              cb.checked = isChecked;
              const id = cb.getAttribute("data-id");
              if (isChecked && !this.checkedLoans.includes(id)) {
                this.checkedLoans.push(id);
              }
            });
          });
        }

        // Checkbox for "Select All Loans"
        const checkboxLoanAll = document.getElementById("checkbox_loan_all");
        if (checkboxLoanAll) {
          checkboxLoanAll.addEventListener("change", (e) => {
            const isChecked = e.target.checked;

            if (isChecked) {
              // Select all loan IDs from allLoans
              this.checkedLoans = this.allLoans.map((loan) => loan.public_id);
            } else {
              // Deselect all
              this.checkedLoans = [];
            }

            // Re-render current page checkboxes
            const pageCheckboxes =
              document.querySelectorAll(".form-check-select");
            pageCheckboxes.forEach((cb) => {
              const id = cb.getAttribute("data-id");
              if (isChecked && !this.checkedLoans.includes(id)) {
                this.checkedLoans.push(id);
              }
            });

            // Also update per-page select-all checkbox if exists
            const selectAll = document.getElementById("select-all-checkbox");
            if (selectAll) {
              selectAll.checked = isChecked;
            }

            this.updatePagination();
          });
        }

        // check all in that pages handler
        const pageCheckboxes = document.querySelectorAll(".form-check-select");
        const currentPageIds = Array.from(pageCheckboxes).map((cb) =>
          cb.getAttribute("data-id")
        );
        const allPageChecked = currentPageIds.every((id) =>
          this.checkedLoans.includes(id)
        );
        if (selectAllCheckbox) {
          selectAllCheckbox.checked = allPageChecked;
        }
      });
    },

    // Edit Loan Status
    confirmBoxWithValue() {
      Swal.fire({
        title: "เปลี่ยนสถานะ",
        html: `<select id="swal-status" class="swal2-select text-center" style="min-width: 200px;">
        <option value="" disabled selected>-- เลือกสถานะ --</option>
        <option value="อยู่ระหว่างดำเนินการ">อยู่ระหว่างดำเนินการ</option>
        <option value="ผ่านการตรวจสอบคุณสมบัติ">ผ่านการตรวจสอบคุณสมบัติ</option>
        <option value="อยู่ระหว่างตรวจสอบคุณสมบัติผู้กู้ยืม">อยู่ระหว่างตรวจสอบคุณสมบัติผู้กู้ยืม</option>
        <option value="รอผลการพิจารณาจากกองทุน กยศ.">รอผลการพิจารณาจากกองทุน กยศ.</option>
        <option value="ตีกลับเพื่อแก้เอกสาร">ตีกลับเพื่อแก้เอกสาร</option>
         <option value="อนุมัติ">อนุมัติ</option>
        <option value="ไม่อนุมัติ">ไม่อนุมัติ</option>
      </select>
      <textarea id="swal-reason" class="swal2-textarea" placeholder="กรุณากรอกรายละเอียดเพิ่มเติม" style="margin-top: 1em;"></textarea>`,
        focusConfirm: false,
        showCancelButton: true,
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "ยืนยัน",
        confirmButtonColor: "#964040",
        preConfirm: () => {
          const status = document.getElementById("swal-status").value;
          const reason = document.getElementById("swal-reason").value.trim();

          if (!status) {
            Swal.showValidationMessage("กรุณาเลือกสถานะ");
            return false;
          }
          return { status, reason };
        },
      }).then((result) => {
        if (result.isConfirmed) {
          const { status, reason } = result.value;
          this.postBulkEditLoanStatus(this.checkedLoans, status, reason);
        }
      });
    },

    async postBulkEditLoanStatus(idArray, newStatus, reason = "") {
      if (!Array.isArray(idArray) || idArray.length === 0) {
        return this.$refs.alertBox.showAlert("กรุณาเลือกรายการ", "warning");
      }

      const updates = idArray.map((id) => ({
        ID: id,
        newStatus,
        reason,
      }));
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/staff/loan/edit/status/bulk`,
          {
            method: "PATCH",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updates),
          }
        );

        if (response.ok) {
          const result = await response.json();

          const summaryLines = result.summary.map(
            (s) => `สถานะ: ${s.status} - จำนวน: ${s.changed} รายการ`
          );

          const failureLines = result.failures.map(
            (f) => `ID: ${f.ID} → ${f.reason}`
          );

          const htmlMessage = `
        <strong>📌 ผลการอัปเดตสถานะ</strong><br/>
        ${summaryLines.join("<br/>")}
        ${
          failureLines.length > 0
            ? "<br/><br/><strong>❌ รายการที่ไม่สำเร็จ:</strong><br/>"
            : ""
        }
        ${failureLines.join("<br/>")}
      `;

          await Swal.fire({
            icon: failureLines.length > 0 ? "warning" : "success",
            title: "ผลการอัปเดต",
            html: htmlMessage,
            confirmButtonText: "ปิด",
          });

          this.getStudentLoanSearch(); // Refresh table
          this.checkedLoans = [];
        } else {
          const error = await response.text();
          Swal.fire({
            icon: "error",
            title: "เกิดข้อผิดพลาด",
            text: error,
          });
        }
      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "เกิดข้อผิดพลาด",
          text: err.message || "Unknown error",
        });
      }
    },

    // Delete Data
    async deleteSystemStatus(publicId) {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/staff/delete/loan?public_id=${publicId}`,
          {
            method: "DELETE",
            credentials: "include", // send cookies/session
          }
        );
        const result = await response.json();
        if (response.ok) {
          this.$refs.alertBox?.showAlert(result.message, "success");
          this.getStudentLoanSearch();
        } else {
          throw new Error(result.error || "Delete failed");
        }
      } catch (error) {
        console.error("Delete error:", error.message);
        this.$refs.alertBox?.showAlert(error.message, "error");
      }
    },

    async getPDFpersonalData(publicId, user_studentID) {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/staff/download-pdf/personalData`,
          {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ public_id: publicId }), // send single string, not array
          }
        );

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.message || "ดาวน์โหลดไม่สำเร็จ");
        }

        const blob = await getVerifiedZipBlob(response);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `loan_form_${user_studentID}.zip`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        this.$refs.alertBox?.showAlert("ดำเนินการดาวน์โหลด", "success");
      } catch (error) {
        console.error("Download error:", error.message);
        this.$refs.alertBox?.showAlert(error.message, "error");
      }
    },

    // Calculate visible pages with ellipsis
    calculateVisiblePages() {
      const totalPages = this.totalPages();
      const maxVisiblePages = 5; // maximum number of visible pages (e.g., 1, 2, 3, ... 8)
      let pages = [];

      if (totalPages <= maxVisiblePages) {
        pages = Array.from({ length: totalPages }, (_, i) => i + 1);
      } else {
        pages = [1, 2, "...", totalPages - 1, totalPages];
      }

      return pages;
    },

    dynamicPageRange() {
      let total = this.totalPages();
      let range = [];

      if (total <= 7) {
        // If total pages are 7 or less, show all pages
        for (let i = 2; i < total; i++) {
          range.push(i);
        }
      } else {
        if (this.currentPage <= 4) {
          // Show first few pages if current page is in the beginning
          range = [2, 3, 4, 5];
        } else if (this.currentPage >= total - 3) {
          // Show last few pages if near the end
          range = [total - 4, total - 3, total - 2, total - 1];
        } else {
          // Show current page in the center with 2 surrounding pages
          range = [
            this.currentPage - 1,
            this.currentPage,
            this.currentPage + 1,
          ];
        }
      }

      return range;
    },

    changePage(page) {
      if (page !== "...") {
        this.currentPage = page;
        this.updatePagination();

        window.scrollTo({
          top: 0,
          behavior: "smooth", // optional for smooth animation
        });
      }
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.updatePagination();
      }
    },

    nextPage() {
      let totalPages = this.totalPages();
      if (this.currentPage < totalPages) {
        this.currentPage++;
        this.updatePagination();
      }
    },

    totalPages() {
      return Math.ceil(this.totalLoan / this.itemsPerPage);
    },

    async getStudentLoanSearch() {
      // const limit = this.itemsPerPage;
      // const offset = (this.currentPage - 1) * this.itemsPerPage;
      this.isLoading = true;
      try {
        // Collect input values
        const allInput = document.querySelectorAll(
          "#search_form input, select"
        );
        let inputDataArray = Array.from(allInput).map((input) => ({
          id: input.id,
          value: input.value,
        }));

        this.sortFields.forEach((sort, index) => {
          inputDataArray.push({ id: `sortKey${index}`, value: sort.key });
          inputDataArray.push({ id: `sortOrder${index}`, value: sort.order });
        });

        // inputDataArray.push({ id: "limit", value: limit });
        // inputDataArray.push({ id: "offset", value: offset });

        // Convert inputDataArray into a query string
        const queryParams = new URLSearchParams();
        inputDataArray
          .filter((input) => input.id && String(input.value).trim() !== "")
          .forEach((input) => queryParams.append(input.id, input.value));
        this.selectedLoanStatuses.forEach((status) =>
          queryParams.append("loan_status", status)
        );
        this.selectedStudentTypes.forEach((studentType) =>
          queryParams.append("user_studentType", studentType)
        );

        // Send the query string to the backend
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/staff/get/loan/search?${queryParams.toString()}`,
          {
            credentials: "include",
          }
        );

        if (response.ok) {
          const staticData = await response.json();
          this.checkedLoans = [];
          this.result_show(staticData);
        } else if (response.status === 500) {
          const errorMessage = await response.text();
          throw new Error(errorMessage);
        } else {
          throw new Error("Connection error");
        }
      } catch (error) {
        console.error(error.message);
        alert(error.message);
      } finally {
        this.isLoading = false;
      }
    },

    clearInput() {
      // Clear all standard inputs, selects, and multi-select filters
      const allInput = document.querySelectorAll(
        "#search_form input, #search_form select"
      );
      allInput.forEach((input) => {
        input.value = "";
      });
      this.studentId = "";
      this.selectedLoanStatuses = [];
      this.selectedStudentTypes = [];

      this.getStudentLoanSearch();
    },

    openLoanModal() {
      this.$refs.loanModal.openModal(this.checkedLoans);
    },
  },

  mounted() {
    this.getStudentLoanSearch();
  },

  watch: {
    itemsPerPage() {
      this.getStudentLoanSearch();
    },
  },
};
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  padding: 80px 0 0 0;
}

.search-fields {
  background: linear-gradient(180deg, #ffffff 0%, #f7f2f2 100%);
  border: 1px solid #e2d4d4;
  border-radius: 12px;
  padding: 16px;
}

.search-fields label {
  font-weight: 600;
  color: #5b2a2a;
  margin-bottom: 6px;
}

.search-fields .form-control,
.search-fields .form-select {
  min-height: 42px;
  border-color: #d6caca;
}

.search-fields .form-control:focus,
.search-fields .form-select:focus {
  border-color: #964040;
  box-shadow: 0 0 0 0.2rem rgba(150, 64, 64, 0.15);
}

.filter-select-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  text-align: left;
}

.filter-select-button i,
.active-filter {
  color: #964040;
}

:global(.loan-filter-popup) {
  max-height: 340px;
  overflow-y: auto;
  text-align: left;
  padding: 0 8px;
}

:global(.loan-filter-option) {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  padding: 8px 4px;
  cursor: pointer;
}

:global(.loan-filter-option .form-check-input) {
  flex: 0 0 auto;
  margin-top: 4px;
}

:global(.loan-filter-all) {
  font-weight: 700;
}

.date-range-wrap {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 12px;
  align-items: center;
}

.date-separator {
  font-weight: 600;
  color: #7a5b5b;
  white-space: nowrap;
}

.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

img {
  width: 100px;
  height: 150px;
}

h1 {
  margin: 0;
  flex-grow: 0.9;
  text-align: center;
}

.waiting-btn {
  background-color: #964040;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.3s;
  margin-left: 65px;
}

.verified-btn {
  background-color: grey;
  color: black;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  margin: 10px;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.verified-btn:hover {
  background-color: #45a049;
}

.py-5 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}

.px-5 {
  padding-left: 3rem;
  padding-right: 3rem;
}

h2 {
  margin-left: 25px;
}

.bg-secondary-light {
  background-color: rgba(108, 117, 125, 0.2);
}

.d-flex {
  gap: 20px;
}

/* สร้าง class สำหรับพื้นหลังสีเหลือง */
.bg-warning {
  background-color: yellow;
}

.no-arrows::-webkit-inner-spin-button,
.no-arrows::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* สำหรับ Firefox */
.no-arrows {
  -moz-appearance: textfield;
}

.table-responsive {
  overflow: hidden;
  width: 100%;
}

.table-responsive table {
  font-size: clamp(10px, 1vw, 13px);
  width: 100%;
}

.table-responsive table th {
  white-space: normal;
  word-break: keep-all;
  vertical-align: middle;
  text-align: center;
  padding: clamp(3px, 0.4vw, 6px) clamp(2px, 0.3vw, 4px);
}

.table-responsive table td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 0;
  vertical-align: top;
  padding: clamp(3px, 0.4vw, 6px) clamp(2px, 0.3vw, 4px);
}

/* ===== Responsive ===== */

/* Tablet (768px - 1199px) */
@media (max-width: 1199px) {
  .table-responsive {
    overflow-x: auto;
  }

  .search-fields {
    padding: 12px;
  }

  .date-range-wrap {
    grid-template-columns: 1fr;
  }

  .date-separator {
    text-align: center;
  }

  .table-responsive table {
    font-size: 11px;
    min-width: 900px;
  }

  .table-responsive table th,
  .table-responsive table td {
    padding: 5px 3px;
  }

  .py-1.px-2 {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  h4 {
    font-size: 1.1rem;
  }
}

/* Mobile (max 767px) */
@media (max-width: 767px) {
  .table-responsive table {
    font-size: 10px;
    min-width: 700px;
  }

  .table-responsive table th,
  .table-responsive table td {
    padding: 4px 3px;
  }

  h4 {
    font-size: 1rem;
  }

  .btn {
    font-size: 12px;
    padding: 4px 8px;
  }

  .pagination-container {
    flex-wrap: wrap;
    gap: 4px;
  }

  .pagination-container .btn {
    font-size: 11px;
    padding: 3px 7px;
  }

  /* Search form stacked on mobile */
  .row.g-3 > .col-md,
  .row.g-3 > .col-md-3,
  .row.g-3 > .col-md-4 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  /* Hide less important columns on mobile */
  .table-responsive table th:nth-child(5),
  .table-responsive table td:nth-child(5),
  .table-responsive table th:nth-child(7),
  .table-responsive table td:nth-child(7),
  .table-responsive table th:nth-child(8),
  .table-responsive table td:nth-child(8),
  .table-responsive table th:nth-child(11),
  .table-responsive table td:nth-child(11),
  .table-responsive table th:nth-child(12),
  .table-responsive table td:nth-child(12) {
    display: none;
  }
}
</style>
